<script lang="ts" setup>
  const props = defineProps({
    type: { type: String, required: false, default: 'h2', validator: (v: string) => ['span', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6'].includes(v) },
    headingStyle: { type: Boolean, required: false, default: false },
  });
</script>
<template>
  <component :is="props.type ?? 'h2'" :role="props.type ==='span' ? 'heading' : null" class="heading" :class="{ headingStyle: props.headingStyle }">
    <slot />
  </component>
</template>
<style>
  :root {
    --sf-heading-color: var(--color-default)
  }
</style>
<style lang="scss" scoped>
  @use "@storefront/styles/mixins/media";

  .heading {
    color: var(--sf-heading-color);
  }

  span {
    font-size: 1rem;
    font-weight: var(--font-weight-semi);
    line-height: 1.7;


    &.headingStyle {
      font-size: 1.625rem;
      font-weight: var(--font-weight-semi);
      line-height: 1.3;

      @include media.query(lg) {
        font-size: 1.375rem;
        line-height: 1.4;
      }
    }
  }
</style>
